<template>
  <div style="padding: 35px 0px;">     
      
       <p class="txtFed" @click="collapse = !collapse">Perguntas e Respostas <img src="/sandboxfront/img/setaSBaixo.svg" alt="" ></p>
    <div v-for="(n,i) in dados.perguntas" :key="i" :class="{blocoPer:true,collapsae:collapse}">
        <div>
           <p class="txtFedA"  @click="collapse = !collapse">{{n.pergunta}} </p>
        </div>
        <div class="okB">
            <button @click="abrir(n.link)">Abrir</button>
        </div>
    </div>
    <p class="txtFed" @click="collapse2 = !collapse2" style="margin-top: 40px;">Matérias <img src="/sandboxfront/img/setaSBaixo.svg" alt=""  ></p>
       <div :class="{collapsae:collapse2}">
        <Bloco :dados="dados.materias" t="federal" />
    </div>
     <p class="txtFed" style="margin-top:40px;" @click="collapse3 = !collapse3">Documentos e Guias <img src="/sandboxfront/img/setaSBaixo.svg" alt="" /></p>
      <div :class="{collapsae:collapse3}">
          <Bloco :dados="dados.documentos" t="d" />
      </div>
  </div>

</template>

<script>
import calculo from '../services/calculo'
import Bloco from '../components/Bloco.vue'
export default {
    components:{
        Bloco
    },
    data(){
        return{
            collapse:false,
            collapse2:false,
            collapse3:false,
            dados:[]
        }
    },
    methods:{
            abrir(n){
                window.open(n,'_blank')
            }
    },
    async mounted(){
      
        let result = await calculo.AplicacaoTrabalhista()
        if(result.status <=205){
            this.dados = result.data
        }
    }

}
</script>

<style>
.collapsae{
  display: none !important;
}
@media screen and (max-width: 600px) {
    .blocoPer{ 
    flex-direction: column;
    
}
.blocoPer button{
     margin-left: 0px !important;
     margin-top:15px;
     width: 100% !important;
}
.okB{
    width: 100%;
}
}
.blocoPer{
    background: #eee;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 20px;
    padding-left: 25px;
    padding-right: 25px;
    margin-top: 26px;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 10px;
    min-height: 60px;
    align-items: center;
    margin-left:30px;
    margin-right: 30px;
}
.txtFedA{
    color:#7e7e7e;
    font-weight: 600;
    cursor: pointer; 
    font-size: 1em;
    margin-bottom: 0px;
    text-align: justify;
}
.blocoPer button{
        background: #4a154b 0 0 no-repeat padding-box;
    border-radius: 10px;
    color: #fff;
    border: #4a154b;
    width: 88px;
    height: 39px;
    font-size: 15px;
    margin-left: 20px;
    text-align: center;
}

</style>